
export const omikujiData = [
  {
    flower: "胡蝶蘭ブルージーン",
    flowerImage: "https://public.readdy.ai/ai/img_res/1e9862dc83b185b9ea8c5f49bf8eadf9.jpg",
    meaning: "奇跡の出会い",
    message: "今日のあなたには特別な奇跡が訪れる予感があります。青い胡蝶蘭のように稀少で美しい出会いや、人生を変えるような素晴らしい出来事が待っているでしょう。この特別な日を心から楽しんでください。",
    luck: "超吉",
    color: "bg-gradient-to-r from-blue-600 to-indigo-600",
    advice: "今日は運命的な出会いがあるかもしれません。いつも以上に心を開いて、新しい可能性を受け入れてください。人生が大きく変わる素晴らしい一日になるでしょう。"
  },
  {
    flower: "胡蝶蘭",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20white%20and%20pink%20orchid%20flowers%20in%20full%20bloom%2C%20elegant%20phalaenopsis%20orchid%20with%20delicate%20petals%2C%20soft%20natural%20lighting%2C%20botanical%20photography%20style%2C%20clean%20white%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=orchid-omikuji&orientation=squarish",
    meaning: "幸福が飛んでくる",
    message: "今日のあなたには素晴らしい幸運が舞い込んできそうです。胡蝶蘭のように優雅で美しい心を持って、周りの人々に愛を分けてあげてください。きっと素敵な出会いや嬉しい知らせがあるでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-pink-500 to-purple-500",
    advice: "今日は積極的に行動することで、新しいチャンスを掴むことができるでしょう。笑顔を忘れずに過ごしてください。"
  },
  {
    flower: "シクラメン",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20red%20and%20pink%20cyclamen%20flowers%20in%20bloom%2C%20delicate%20heart-shaped%20petals%2C%20vibrant%20colors%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=cyclamen-omikuji&orientation=squarish",
    meaning: "内気な愛",
    message: "今日のあなたは少し控えめかもしれませんが、その優しさが周りの人の心を温めています。シクラメンのように、静かな美しさの中に強い愛を秘めているあなたの魅力が輝く日です。",
    luck: "中吉",
    color: "bg-gradient-to-r from-red-500 to-pink-500",
    advice: "恥ずかしがらずに、あなたの気持ちを大切な人に伝えてみましょう。きっと良い反応が返ってくるはずです。"
  },
  {
    flower: "チランジア",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20air%20plant%20tillandsia%20with%20silver-green%20leaves%20and%20purple%20flower%20spike%2C%20unique%20epiphyte%20plant%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20plant%20structure&width=400&height=400&seq=tillandsia-omikuji&orientation=squarish",
    meaning: "不屈の精神",
    message: "土がなくても美しく咲くチランジアのように、あなたには困難な状況でも力強く生きる素晴らしい力があります。今日は自分の可能性を信じて、新しいことにチャレンジしてみてください。",
    luck: "吉",
    color: "bg-gradient-to-r from-green-500 to-teal-500",
    advice: "今日は自分らしさを大切にして、周りに流されずに自分の道を歩んでください。あなたの個性が評価される日です。"
  },
  {
    flower: "桜",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20cherry%20blossom%20sakura%20flowers%20in%20full%20bloom%2C%20delicate%20pink%20petals%2C%20spring%20atmosphere%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20clusters&width=400&height=400&seq=sakura-omikuji&orientation=squarish",
    meaning: "精神美",
    message: "桜のように美しく散りゆく花のように、今日のあなたには潔い美しさがあります。過去にとらわれず、新しいスタートを切る絶好の日です。変化を恐れずに前進しましょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-pink-400 to-rose-400",
    advice: "今日は新しい出会いや機会に恵まれそうです。心を開いて、素敵な変化を受け入れてください。"
  },
  {
    flower: "ひまわり",
    flowerImage: "https://readdy.ai/api/search-image?query=Bright%20yellow%20sunflower%20in%20full%20bloom%2C%20large%20flower%20head%20with%20golden%20petals%2C%20cheerful%20and%20vibrant%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=sunflower-omikuji&orientation=squarish",
    meaning: "憧れ",
    message: "太陽に向かって咲くひまわりのように、今日のあなたは明るく前向きなエネルギーに満ちています。あなたの笑顔が周りの人々を元気にし、素敵な一日を作り出すでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-yellow-400 to-orange-400",
    advice: "今日は積極的にコミュニケーションを取ることで、新しい友情や恋愛のチャンスが生まれそうです。"
  },
  {
    flower: "薔薇",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20red%20rose%20in%20full%20bloom%2C%20velvety%20petals%2C%20classic%20romantic%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure%20with%20thorns&width=400&height=400&seq=rose-omikuji&orientation=squarish",
    meaning: "愛",
    message: "薔薇の女王のように、今日のあなたには特別な魅力があります。愛に関する嬉しい出来事が起こりそうです。大切な人との絆が深まったり、新しい恋の予感があるかもしれません。",
    luck: "中吉",
    color: "bg-gradient-to-r from-red-500 to-rose-500",
    advice: "今日は愛情表現を大切にしてください。感謝の気持ちを言葉にして伝えることで、関係がより深まるでしょう。"
  },
  {
    flower: "カスミソウ",
    flowerImage: "https://readdy.ai/api/search-image?query=Delicate%20white%20baby%20breath%20flowers%2C%20small%20clustered%20blooms%2C%20airy%20and%20light%20appearance%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20tiny%20flower%20structure&width=400&height=400&seq=babysbreath-omikuji&orientation=squarish",
    meaning: "清らかな心",
    message: "小さくても美しいカスミソウのように、今日のあなたには純粋で清らかな心の美しさがあります。些細なことにも感謝の気持ちを持って過ごすことで、幸せを感じられる一日になるでしょう。",
    luck: "小吉",
    color: "bg-gradient-to-r from-gray-400 to-blue-400",
    advice: "今日は周りの人への思いやりを大切にしてください。小さな親切が大きな幸せを運んでくれます。"
  },
  {
    flower: "コスモス",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20pink%20cosmos%20flowers%20swaying%20in%20breeze%2C%20delicate%20petals%2C%20autumn%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=cosmos-omikuji&orientation=squarish",
    meaning: "調和",
    message: "風に揺れるコスモスのように、今日のあなたには周りとの調和を大切にする美しい心があります。人間関係において良いバランスを保ち、平和で穏やかな一日を過ごせるでしょう。",
    luck: "吉",
    color: "bg-gradient-to-r from-pink-400 to-purple-400",
    advice: "今日は争いを避けて、平和的な解決を心がけてください。あなたの優しさが周りの雰囲気を良くします。"
  },
  {
    flower: "スイートピー",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20sweet%20pea%20flowers%20in%20pastel%20colors%2C%20delicate%20butterfly-like%20petals%2C%20climbing%20vine%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=sweetpea-omikuji&orientation=squarish",
    meaning: "門出",
    message: "蝶のような美しい花を咲かせるスイートピーのように、今日のあなたには新しい始まりの予感があります。これまでの努力が実を結び、素晴らしい門出の日となりそうです。",
    luck: "大吉",
    color: "bg-gradient-to-r from-purple-400 to-pink-400",
    advice: "今日は新しいことを始めるのに最適な日です。勇気を出して一歩踏み出してみてください。"
  },
  {
    flower: "忘れな草",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20blue%20forget-me-not%20flowers%2C%20tiny%20delicate%20blooms%2C%20soft%20blue%20petals%20with%20yellow%20centers%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20small%20flower%20clusters&width=400&height=400&seq=forgetmenot-omikuji&orientation=squarish",
    meaning: "真実の愛",
    message: "小さくても印象深い忘れな草のように、今日のあなたには人の心に残る特別な魅力があります。真心を込めた行動が、大切な人との絆をより深めてくれるでしょう。",
    luck: "中吉",
    color: "bg-gradient-to-r from-blue-400 to-indigo-400",
    advice: "今日は過去の美しい思い出を大切にしながら、新しい思い出作りにも積極的になってください。"
  },
  {
    flower: "カーネーション",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20pink%20carnation%20flowers%20in%20full%20bloom%2C%20ruffled%20petals%2C%20classic%20elegant%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=carnation-omikuji&orientation=squarish",
    meaning: "母の愛",
    message: "カーネーションのように温かく包み込むような愛情を持つあなた。今日は家族や大切な人への感謝の気持ちが溢れる日です。その優しさが周りの人々を幸せにしています。",
    luck: "中吉",
    color: "bg-gradient-to-r from-pink-500 to-red-400",
    advice: "今日は家族や親しい人に感謝の言葉を伝えてみましょう。心温まる時間が過ごせるはずです。"
  },
  {
    flower: "ラベンダー",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20purple%20lavender%20flowers%20in%20bloom%2C%20fragrant%20herb%20flower%20spikes%2C%20calming%20and%20peaceful%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=lavender-omikuji&orientation=squarish",
    meaning: "沈黙",
    message: "ラベンダーの香りのように、今日のあなたには心を落ち着かせる穏やかな力があります。静かな時間の中で、自分自身と向き合うことで新しい発見があるでしょう。",
    luck: "吉",
    color: "bg-gradient-to-r from-purple-500 to-indigo-500",
    advice: "今日は静かな時間を大切にして、自分の内面と対話してみてください。心の平和が訪れます。"
  },
  {
    flower: "チューリップ",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20red%20tulip%20flowers%20in%20full%20bloom%2C%20elegant%20cup-shaped%20petals%2C%20spring%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=tulip-omikuji&orientation=squarish",
    meaning: "思いやり",
    message: "春の訪れを告げるチューリップのように、今日のあなたには新鮮で明るいエネルギーがあります。あなたの思いやりが周りの人々に希望と喜びをもたらすでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-red-400 to-pink-500",
    advice: "今日は周りの人への思いやりを行動で示してみましょう。小さな優しさが大きな幸せを生み出します。"
  },
  {
    flower: "マーガレット",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20white%20marguerite%20daisy%20flowers%20in%20bloom%2C%20simple%20pure%20petals%20with%20yellow%20center%2C%20cheerful%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=marguerite-omikuji&orientation=squarish",
    meaning: "真実の愛",
    message: "純白のマーガレットのように、今日のあなたには純粋で誠実な心があります。恋占いの花としても知られるマーガレットが、あなたの恋愛運を高めてくれそうです。",
    luck: "中吉",
    color: "bg-gradient-to-r from-white to-yellow-300",
    advice: "今日は素直な気持ちを大切にしてください。正直な心が良い結果を招きます。"
  },
  {
    flower: "ガーベラ",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20orange%20gerbera%20daisy%20flower%20in%20full%20bloom%2C%20vibrant%20cheerful%20petals%2C%20large%20flower%20head%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=gerbera-omikuji&orientation=squarish",
    meaning: "希望",
    message: "明るく元気なガーベラのように、今日のあなたには希望に満ちたエネルギーがあります。前向きな気持ちが、素晴らしい未来への扉を開いてくれるでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-orange-400 to-yellow-400",
    advice: "今日は希望を持って新しいことにチャレンジしてみましょう。あなたの明るさが成功を引き寄せます。"
  },
  {
    flower: "アジサイ",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20blue%20hydrangea%20flowers%20in%20full%20bloom%2C%20clustered%20petals%2C%20elegant%20summer%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=hydrangea-omikuji&orientation=squarish",
    meaning: "家族団らん",
    message: "色を変えながら咲くアジサイのように、今日のあなたには柔軟性と適応力があります。家族や仲間との絆が深まり、温かい時間を過ごせる日です。",
    luck: "吉",
    color: "bg-gradient-to-r from-blue-400 to-purple-400",
    advice: "今日は家族や親しい人と過ごす時間を大切にしてください。心温まる会話が生まれるでしょう。"
  },
  {
    flower: "ユリ",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20white%20lily%20flower%20in%20full%20bloom%2C%20elegant%20large%20petals%2C%20graceful%20and%20pure%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=lily-omikuji&orientation=squarish",
    meaning: "純粋",
    message: "気高く美しいユリのように、今日のあなたには品格と純粋さがあります。その清らかな心が、周りの人々を魅了し、尊敬を集めるでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-white to-pink-300",
    advice: "今日は自分の信念を大切にして、誠実に行動してください。あなたの純粋さが評価されます。"
  },
  {
    flower: "スズラン",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20white%20lily%20of%20the%20valley%20flowers%2C%20delicate%20bell-shaped%20blooms%2C%20spring%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20small%20flower%20structure&width=400&height=400&seq=lilyofvalley-omikuji&orientation=squarish",
    meaning: "幸福の再来",
    message: "小さな鈴のような花を咲かせるスズランのように、今日のあなたには幸せが戻ってくる予感があります。過去の良い思い出が新しい形で蘇るかもしれません。",
    luck: "中吉",
    color: "bg-gradient-to-r from-green-400 to-white",
    advice: "今日は過去の良い経験を思い出して、それを今に活かしてみましょう。新しい幸せが見つかります。"
  },
  {
    flower: "ダリア",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20red%20dahlia%20flower%20in%20full%20bloom%2C%20layered%20petals%2C%20dramatic%20and%20elegant%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=dahlia-omikuji&orientation=squarish",
    meaning: "華麗",
    message: "豪華で華やかなダリアのように、今日のあなたには特別な輝きがあります。自信を持って行動することで、周りの注目を集め、素晴らしい成果を上げられるでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-red-500 to-orange-500",
    advice: "今日は自信を持って自分を表現してください。あなたの魅力が最大限に発揮される日です。"
  },
  {
    flower: "アネモネ",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20red%20anemone%20flower%20in%20bloom%2C%20delicate%20poppy-like%20petals%20with%20dark%20center%2C%20spring%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=anemone-omikuji&orientation=squarish",
    meaning: "期待",
    message: "風の花と呼ばれるアネモネのように、今日のあなたには期待に満ちた未来が待っています。新しい可能性に心を開いて、ワクワクする気持ちを大切にしてください。",
    luck: "吉",
    color: "bg-gradient-to-r from-red-400 to-purple-400",
    advice: "今日は未来への期待を持って、新しいことに挑戦してみましょう。素敵な発見があるはずです。"
  },
  {
    flower: "カトレア",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20purple%20cattleya%20orchid%20flower%20in%20full%20bloom%2C%20elegant%20large%20petals%2C%20luxurious%20tropical%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=cattleya-omikuji&orientation=squarish",
    meaning: "優美な貴婦人",
    message: "蘭の女王カトレアのように、今日のあなたには気品と優雅さがあります。その洗練された魅力が、周りの人々を魅了し、特別な日となるでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-purple-500 to-pink-500",
    advice: "今日は自分の魅力を信じて、堂々と振る舞ってください。あなたの優雅さが輝きます。"
  },
  {
    flower: "フリージア",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20yellow%20freesia%20flowers%20in%20bloom%2C%20delicate%20fragrant%20blooms%2C%20spring%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=freesia-omikuji&orientation=squarish",
    meaning: "純潔",
    message: "甘い香りのフリージアのように、今日のあなたには清らかで純粋な魅力があります。その誠実な心が、周りの人々に安心感と信頼を与えるでしょう。",
    luck: "中吉",
    color: "bg-gradient-to-r from-yellow-400 to-white",
    advice: "今日は誠実さを大切にして、正直に行動してください。あなたの純粋さが評価されます。"
  },
  {
    flower: "ポピー",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20red%20poppy%20flower%20in%20bloom%2C%20delicate%20paper-like%20petals%2C%20vibrant%20spring%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=poppy-omikuji&orientation=squarish",
    meaning: "慰め",
    message: "優しく揺れるポピーのように、今日のあなたには人を癒す力があります。あなたの優しさが、誰かの心を軽くし、笑顔を取り戻させてくれるでしょう。",
    luck: "吉",
    color: "bg-gradient-to-r from-red-400 to-orange-400",
    advice: "今日は困っている人に手を差し伸べてみましょう。あなたの優しさが誰かを救います。"
  },
  {
    flower: "ジャスミン",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20white%20jasmine%20flowers%20in%20bloom%2C%20small%20star-shaped%20fragrant%20blooms%2C%20delicate%20and%20pure%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=jasmine-omikuji&orientation=squarish",
    meaning: "愛らしさ",
    message: "甘い香りのジャスミンのように、今日のあなたには人を惹きつける魅力があります。その愛らしさが、周りの人々を幸せな気持ちにさせるでしょう。",
    luck: "中吉",
    color: "bg-gradient-to-r from-white to-green-300",
    advice: "今日は自然体でいることを心がけてください。ありのままのあなたが一番魅力的です。"
  },
  {
    flower: "クレマチス",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20purple%20clematis%20flower%20in%20full%20bloom%2C%20large%20star-shaped%20petals%2C%20climbing%20vine%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=clematis-omikuji&orientation=squarish",
    meaning: "精神の美",
    message: "つる性の美しいクレマチスのように、今日のあなたには柔軟性と強さを兼ね備えた美しさがあります。困難な状況でも、しなやかに対応できる力を持っています。",
    luck: "吉",
    color: "bg-gradient-to-r from-purple-400 to-blue-400",
    advice: "今日は柔軟な考え方を大切にしてください。固定観念にとらわれず、新しい視点を持ちましょう。"
  },
  {
    flower: "ブーゲンビリア",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20pink%20bougainvillea%20flowers%20in%20bloom%2C%20vibrant%20tropical%20flower%2C%20colorful%20bracts%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=bougainvillea-omikuji&orientation=squarish",
    meaning: "情熱",
    message: "鮮やかなブーゲンビリアのように、今日のあなたには情熱的なエネルギーが溢れています。その熱い想いが、素晴らしい結果を生み出し、夢の実現に近づけるでしょう。",
    luck: "大吉",
    color: "bg-gradient-to-r from-pink-500 to-red-500",
    advice: "今日は情熱を持って物事に取り組んでください。あなたの熱意が周りを動かし、成功を引き寄せます。"
  },
  {
    flower: "プルメリア",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20white%20and%20yellow%20plumeria%20frangipani%20flowers%20in%20bloom%2C%20tropical%20flower%20with%20sweet%20fragrance%2C%20elegant%20petals%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=plumeria-omikuji&orientation=squarish",
    meaning: "気品",
    message: "南国の花プルメリアのように、今日のあなたには優雅で気品のある魅力があります。リラックスした雰囲気の中で、あなたの本来の美しさが輝く日です。",
    luck: "中吉",
    color: "bg-gradient-to-r from-yellow-300 to-pink-300",
    advice: "今日は心に余裕を持って、ゆったりと過ごしてください。リラックスした状態が最高の結果を生みます。"
  },
  {
    flower: "ストック",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20pink%20stock%20flowers%20in%20bloom%2C%20fragrant%20clustered%20blooms%2C%20spring%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=stock-omikuji&orientation=squarish",
    meaning: "永遠の美",
    message: "甘い香りのストックのように、今日のあなたには時を超えた美しさがあります。内面から輝く魅力が、周りの人々を魅了し、長く心に残る印象を与えるでしょう。",
    luck: "吉",
    color: "bg-gradient-to-r from-pink-400 to-purple-300",
    advice: "今日は内面の美しさを磨くことを意識してください。心の豊かさが外見にも表れます。"
  },
  {
    flower: "ネモフィラ",
    flowerImage: "https://readdy.ai/api/search-image?query=Beautiful%20blue%20nemophila%20baby%20blue%20eyes%20flowers%20in%20bloom%2C%20delicate%20small%20blooms%2C%20spring%20flower%2C%20botanical%20photography%20style%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20detailed%20flower%20structure&width=400&height=400&seq=nemophila-omikuji&orientation=squarish",
    meaning: "どこでも成功",
    message: "青空のようなネモフィラのように、今日のあなたにはどんな場所でも輝ける力があります。新しい環境や挑戦を恐れず、自信を持って進んでください。",
    luck: "大吉",
    color: "bg-gradient-to-r from-blue-300 to-cyan-300",
    advice: "今日は新しい場所や環境に飛び込んでみましょう。あなたならどこでも成功できます。"
  }
];
